

import { Component, Vue, Prop } from "vue-property-decorator";
import { config } from "../../Store/config";
import { ParticaEvent, eParticaAction } from "../../Models/ParticaEvent";
import { ButtonConfig, ButtonType } from "../../Models/Buttons";
@Component({
	name: "ParticaBaseForm"
})
export default class ParticaBaseForm<T> extends Vue {
	@Prop() protected buttons: ButtonConfig[];
	@Prop() protected model: T;
	protected validform: boolean = true; // is form valid - from v-form.
	protected get formvalid() {
		return this.validform;
	}
	// validate everything on the form.
	protected async validate(): Promise<boolean> {			{
			let result: boolean = false;
			await this.$validator.validateAll().then(valid => result = valid);
			return result;
		}
	}

	protected raiseEvent(event: string, action: eParticaAction, item: any) {
		const pevent: ParticaEvent = { action, item } as ParticaEvent;
		this.$emit(event, pevent);
	}

	protected async buttonClicked(clicked: ParticaEvent) {
		{
			try {
				// find button that was clicked and validate form if it was OK.
				const clickedButton = this.buttons.find(bb => bb.action === clicked.action);
				if (clickedButton === undefined) {
					throw new Error("Button action not found.");
				}
				if (clickedButton.type === ButtonType.OK) {
					if (await this.validate()) {
						clicked.item = this.model;
						this.$emit("partica-event", clicked);
					}
				} else {
					clicked.item = this.model;
					this.$emit("partica-event", clicked);
				}
			} catch (error) {
				console.error(error);
			}
		}
	}

}
